import { Grid } from "@material-ui/core";
import { useVerifyPermission } from "@airborne/react-admin";
import * as React from "react";
import { FC, Fragment } from "react";
import { Datagrid, Filter, FilterProps, FunctionField, ListProps, TextField, TextInput } from "react-admin";
import { CustomDateField } from "../../../Components/CustomDateField";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { TabbedDatagridProps } from "../../../Models/TabbedDataGridProps";
import { SourcePbhRequestOrder, SourceRequestOrder } from "./Constant/Source";
import { PbhRequestStatus } from "../../../Enums/PbhRequestStatus";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { DetailButton } from "../../../Components/DetailButton";
import { SourceVwUser } from "../../../Constants/Source";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  return (
    <Fragment>
      <Datagrid optimized basePath={SourceRequestOrder}>
        <FunctionField
          style={{ fontSize: 12 }}
          render={(record: any) => <DetailButton record={record} resource={"pbhrequestorders"} />}
        />
        <TextField source="refNo" label="Ref No" />
        <TextField source="customerPo" label="Customer Po" />
        <TextField source="ownerCode" label="Customer" />
        <TextField source="pn" label="Pn" />
        <TextField source="airportCode" label="Airport" />
        <TextField source="acRegistration" label="Aircraft" />
        <CustomDateField source="createdDate" label="Created Date" showTime />
        <CreatedByField label="Created By" link={false} />
        <CustomDateField source="rejectedDate" label="Rejected Date" showTime />
        <CreatedByField source="rejectedBy" label="Rejected By" link={false} />
        <TextField source="rejectNote" label="Reject Note" />
      </Datagrid>
    </Fragment>
  );
};

const RejectedPoolScopeList: FC<ListProps> = props => {
  useVerifyPermission("customroutes", "rejectedpoolscope.read");

  const ExportToExcel = (data, fetchRelatedRecords) => {
    fetchRelatedRecords(data, "rejectedBy", SourceVwUser).then(rejectedBy => {
      fetchRelatedRecords(data, "createdBy", SourceVwUser).then(createdBy => {
        const record = data.map(record => ({
          ...record,
          rejectedBy: `${rejectedBy[record.rejectedBy]?.registerId ?? record.rejectedBy} ${rejectedBy[record.rejectedBy]?.name ? "-" + rejectedBy[record.rejectedBy]?.name : ""}`,
          createdBy: `${createdBy[record.createdBy]?.registerId ?? record.createdBy} ${createdBy[record.createdBy]?.name ? "-" + createdBy[record.createdBy]?.name : ""}`,
        }));
        ExcelExport(
          [
            {
              header: "Ref No",
              key: "Ref No",
            },
            {
              header: "Customer Po",
              key: "Customer Po",
            },
            {
              header: "Customer",
              key: "Owner Code",
            },
            {
              header: "Pn",
              key: "Pn",
            },
            {
              header: "Airport",
              key: "Airport Code",
            },
            {
              header: "Aircraft",
              key: "AcRegistration",
            },
            {
              header: "Created Date",
              key: "Created Date",
            },
            {
              header: "Created By",
              key: "Created By",
            },
            {
              header: "Rejected Date",
              key: "Rejected Date",
            },
            {
              header: "Rejected By",
              key: "Rejected By",
            },
            {
              header: "Reject Note",
              key: "Reject Note",
            },
          ],
          record.map(v => [
            v.refNo,
            v.customerPo,
            v.ownerCode,
            v.pn,
            v.airportCode,
            v.acRegistration,
            v?.createdDate,
            v.createdBy,
            v?.rejectedDate ? v?.rejectedDate : "",
            v.rejectedBy,
            v.rejectNote,
          ]),
          "Rejected Pool Scope List"
        );
      });
    });
  };

  const RejectedPoolScopeFilter: FC<Omit<FilterProps, "children">> = props => (
    <Filter {...props}>
      <TextInput label="Ref No" source="refNo__contains" alwaysOn />
      <TextInput label="Customer PO" source="customerPo__contains" alwaysOn />
      <TextInput label="Customer" source="ownerCode__contains" alwaysOn />
      <TextInput label="Pn" source="pn__contains" alwaysOn />
      <TextInput label="Airport" source="airportCode__contains" alwaysOn />
      <TextInput label="Aircraft" source="acRegistration__contains" alwaysOn />
    </Filter>
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <PoolList
          {...props}
          hasCreate={false}
          exporter={ExportToExcel}
          bulkActionButtons={false}
          resource={SourcePbhRequestOrder}
          basePath={SourcePbhRequestOrder}
          title="Rejected Pool Scope"
          filterDefaultValues={{
            requestStatus__eq: PbhRequestStatus.RejectedDueToPoolScope,
          }}
          sort={DefaultCreatedDateSort}
          perPage={DefaultPerPageSize}
          filters={<RejectedPoolScopeFilter />}
        >
          <TabbedDatagrid />
        </PoolList>
      </Grid>
    </Grid>
  );
};

export default RejectedPoolScopeList;
